import { render } from "./DepositTermsAndConditionModals.vue?vue&type=template&id=33bca24f"
import script from "./DepositTermsAndConditionModals.vue?vue&type=script&lang=js"
export * from "./DepositTermsAndConditionModals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__